export const CustomerTableConstant = {
  CUSTOMER_TABLE_SAGA: "CUSTOMER_TABLE_SAGA",
  CUSTOMER_TABLE_REQUEST: "CUSTOMER_TABLE_REQUEST",
  CUSTOMER_TABLE_RESPONSE: "CUSTOMER_TABLE_RESPONSE",
  CUSTOMER_TABLE_API: "/vendor/customers",
};
